import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, createBlock as _createBlock, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-29b4a582"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "attribute-index-page" }
const _hoisted_2 = { class: "attributes-list-header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Produkt attributter", -1))
const _hoisted_4 = { class: "attributes-list-header__buttons" }
const _hoisted_5 = {
  key: 0,
  class: "empty-attributes"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Ingen produkt attributter funnet!", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Start med å legge til nye", -1))
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = { class: "attribute-list" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "attribute-modal" }
const _hoisted_12 = { class: "attribute-name" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Navn", -1))
const _hoisted_14 = { class: "form-actions" }

import {mdiLoading, mdiMenuDown, mdiMenuUp} from "@mdi/js";

import {ref} from 'vue';
import ProductAttributeComponent from "@/Components/ProductAttributes/ProductAttributeComponent.vue";
import ProductAttribute from "@/types/ProductAttribute";
import ProductAttributeOption from "@/types/ProductAttributeOption";
import Messages from "@/Components/General/Messages.vue";
import ProductFilter from "@/Components/Product/ProductFilter.vue";
import Card from "@/Components/General/Card.vue";
import ProductList from "@/Components/Product/ProductList.vue";
import Button from "@/Components/Buttons/Button.vue";
import Modal from "@/Components/General/Modal.vue";
import {useForm} from "@inertiajs/inertia-vue3";
import {computed} from "@vue/reactivity";
import SvgIcon from "@jamescoyle/vue-icon";
import ValidationErrors from "@/Components/Forms/ValidationErrors.vue";
import ValidationFormErrors from "@/Components/Forms/ValidationFormErrors.vue";



import AppLayoutVue from "@/Layouts/AppLayout.vue";


const __default__ = {
  layout: AppLayoutVue,

}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'Attributes',
  props: {
    attributes: {}
  },
  setup(__props: any) {

const props = __props;



const form = useForm<any>({
  name: null,
})
const newAttribute = ref(false);
const attributeCollapsed = ref<any>({});
const toggleAttribute = (attribute: ProductAttribute) => {
  attributeCollapsed.value[attribute.id] = !attributeCollapsed.value[attribute.id];
};


const storeAttribute = () => {
  form.post(route("attributes.store"), {
    preserveScroll: true,
    onSuccess: (page: any) => {
      form.reset()
      newAttribute.value = false;

    },
  })
};


const closeAttributeForm = () => {
  newAttribute.value = false;
  form.reset();
  form.clearErrors()

}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", null, [
        _createVNode(Messages, { class: "attribute-index-messages" }),
        _createElementVNode("header", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createVNode(Button, {
              class: "button-with-icon",
              color: "primary",
              type: "a",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (newAttribute.value = true))
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Ny attributt ")
              ]),
              _: 1
            })
          ])
        ])
      ]),
      (!_ctx.attributes.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_8))
        : (_openBlock(), _createBlock(Card, {
            key: 1,
            class: "attributes-card"
          }, {
            default: _withCtx(() => [
              _createElementVNode("ul", _hoisted_9, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.attributes, (attribute) => {
                  return (_openBlock(), _createBlock(ProductAttributeComponent, {
                    collapsed: !attributeCollapsed.value[attribute.id],
                    onToggleAttribute: toggleAttribute,
                    key: attribute.id,
                    attribute: attribute
                  }, {
                    toggle: _withCtx(() => [
                      _createElementVNode("span", {
                        onClick: ($event: any) => (toggleAttribute(attribute)),
                        class: "toggle-button"
                      }, [
                        (!attributeCollapsed.value[attribute.id])
                          ? (_openBlock(), _createBlock(_unref(SvgIcon), {
                              key: 0,
                              type: "mdi",
                              size: "32",
                              path: _unref(mdiMenuUp)
                            }, null, 8, ["path"]))
                          : (_openBlock(), _createBlock(_unref(SvgIcon), {
                              key: 1,
                              type: "mdi",
                              path: _unref(mdiMenuDown),
                              size: "32"
                            }, null, 8, ["path"]))
                      ], 8, _hoisted_10)
                    ]),
                    _: 2
                  }, 1032, ["collapsed", "attribute"]))
                }), 128))
              ])
            ]),
            _: 1
          }))
    ]),
    (newAttribute.value)
      ? (_openBlock(), _createBlock(Modal, { key: 0 }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_11, [
              _createVNode(ValidationFormErrors, {
                errors: _unref(form).errors
              }, null, 8, ["errors"]),
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(form).name) = $event))
                }, null, 512), [
                  [_vModelText, _unref(form).name]
                ])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createVNode(Button, {
                  color: "gray",
                  onClick: closeAttributeForm
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Lukk ")
                  ]),
                  _: 1
                }),
                _createVNode(Button, {
                  disabled: _unref(form).processing,
                  color: "green",
                  onClick: storeAttribute
                }, {
                  default: _withCtx(() => [
                    (_unref(form).processing)
                      ? (_openBlock(), _createBlock(_unref(SvgIcon), {
                          key: 0,
                          class: "animate-spin",
                          type: "mdi",
                          path: _unref(mdiLoading)
                        }, null, 8, ["path"]))
                      : _createCommentVNode("", true),
                    _createTextVNode(" Lagre ")
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ])
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})